import "./index.scss";

import React from "react";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import { MainRoutes, OtherRoutes } from "./Config";
import Tooltip from "@/src/components/common/Elements/Tooltip/Tooltip";
import Axios from "Source/axiosPool";

@connect(store => {
    return {
        common: store.common,
        loggedUser: store.loggedUser,
        socket: store.socket.container
    }
})

class Sidebar extends React.Component {
    constructor(props) {
        super(props);

        _.map([ "showLeft", "onOverlay", "onClose", "onLogout" ], fn => {
            this[fn] = this[fn].bind(this);
        });
    }

    onClose() {
        const { dispatch, common } = this.props;
        
        if( common.sidepanelStatus === "overlay" ) {
            dispatch({ type: "COMMON_UPDATE_SIDEPANEL_STATUS", status: "icon-only" });
        }
    }

    showLeft() {
        const { dispatch } = this.props;

        dispatch({ type: "COMMON_UPDATE_SIDEPANEL_STATUS", status: "default" })
    }

    onOverlay(e, cb) {
        const { dispatch, common } = this.props;
        
        if( common.sidepanelStatus === "icon-only" ) {
            e.preventDefault();

            dispatch({ type: "COMMON_UPDATE_SIDEPANEL_STATUS", status: "overlay" });
        } else {
            if( cb ) { 
                cb();
            }
        }
    }

    onLogout() {
        const { loggedUser, socket } = this.props;

        Axios.delete(`/api/login/${loggedUser.data.id}`) 
            .then(c => {
                socket.disconnect();
                
                window.location.replace("/");

                showToast("success", "Successfully Logged Out");
            });
    }
    
    render() {
        const { common, loggedUser, history, isShowAccounts = true } = this.props;
        const main = MainRoutes({ loggedUser, history, isShowAccounts });
        const others = OtherRoutes({ loggedUser, onLogout: this.onLogout });

        const isActive = (match, location) => {
            if( match ) {
                if( match.url === location.pathname ) {
                    return true;
                }
            }

            return false;
        }

        return (
            <ClickAwayListener onClickAway={this.onClose}>
                <div id="main-sidebar" class={`sidepanel-${this.props.common.sidepanelStatus}`}>
                    <div class="menu-sidebar-container">
                        <div class="menu-main">
                            <div class="menu-item logoContainer">
                                <img src={`/images/${common.sidepanelStatus === "icon-only" ? "cloudcfo-logo-white-icon-only.png" : "cloudcfo-logo-white-icon-beside-text.png"}`} style={{height: '25px'}} />
                                { common.sidepanelStatus === "overlay" && (
                                    <a onClick={this.showLeft}>
                                        <i class="material-icons mr0">menu</i>
                                        <i class="material-icons mr5">chevron_right</i>
                                    </a>
                                )}
                            </div>
                            <div class="menu-container main-menus">
                                { Object.keys(main).filter(k => !main[k].hidden).map(k => {
                                    return (
                                        <div key={`main_menu_sidebar_menu_${k}`} class={`menu-item menu-${k}`}>
                                            { Boolean(main[k].component) && React.cloneElement(main[k].component, {
                                                onClick: this.onOverlay,
                                                isActive: isActive,
                                                sidepanelStatus: common.sidepanelStatus
                                            }) }
                                            { !main[k].component && (
                                                <NavLink to={ main[k].path } onClick={this.onOverlay} isActive={isActive}    data-tooltip-id={`menu_project_item_${main[k].label}`}>
                                                    { main[k].icon }
                                                    { this.props.common.sidepanelStatus !== "icon-only" && main[k].label }

                                                    { this.props.common.sidepanelStatus === "icon-only" &&
                                                        <Tooltip id={`menu_project_item_${main[k].label}`} place="right" effect="solid">
                                                            { main[k].label }
                                                        </Tooltip>
                                                    }
                                                </NavLink>
                                            ) }
                                        </div>
                                    );
                                }) }
                            </div>
                        </div>
                        <div class="menu-container other-menus">
                            { Object.keys(others).filter(k => !others[k].hidden).map(k => {
                                return (
                                    <div key={`other_menu_qssidebar_menu_${k}`} class={`menu-item menu-${k}`}>
                                        { !others[k].component && (
                                            <NavLink to={ others[k].path } onClick={ (e) => this.onOverlay( e, () => others[k].customClick ? others[k].customClick(e) : null ) }    data-tooltip-id={`menu_project_item_${others[k].label}`}>
                                                { others[k].icon }
                                                { this.props.common.sidepanelStatus !== "icon-only" && 
                                                    <span>{others[k].label.length > 24 ? `${others[k].label.substring(0, 24)}...` : others[k].label}</span>
                                                }
                                                { this.props.common.sidepanelStatus === "icon-only" &&
                                                    <Tooltip id={`menu_project_item_${others[k].label}`} place="right" effect="solid">
                                                        { others[k].label }
                                                    </Tooltip>
                                                }
                                            </NavLink>
                                        ) }
                                    </div>
                                );
                            }) }
                        </div>
                    </div>
                </div>
            </ClickAwayListener>
        );
    }
}

export default Sidebar;